import $ from 'jquery';
import get from 'lodash/get';
import removeQueryParam from '../../helpers/remove-query-param';

export default function(){
    const categoryMenu = get(window, 'rcProps.trigger.global.categoryId', false);
    if (categoryMenu === 1) {
        $(".js-category-menu").trigger("click");
        removeQueryParam('openQuickNav');
    }
};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/header/amp-category-menu.js